<template>
  <div id="privacy-page" class="content">
    <h4>About Us</h4>
    <p>
      We are OpenLikes Tech, Inc. (
      <strong>“OpenLikes”</strong>, <strong>“us”</strong>, <strong>“we”</strong> or
      <strong>“our”</strong>), a corporation registered under the laws of the state of Delaware in
      the United States with its principal office address at 660 4th Street #558, San Francisco, CA
      94107, USA.
    </p>
    <hr />
    <h4>About the OpenLikes Services</h4>
    <p>
      We provide users (
      <strong>“you”</strong>, <strong>“your”</strong>) with services, delivered via the OpenLikes
      website (currently located at
      <a href="http://www.openlikes.com">http://www.openlikes.com</a>), (the
      <strong>“Site”</strong>), the OpenLikes mobile applications, browser extensions, and/or any
      other platform or media through which we may make such services available from time to time,
      that allow you to explore the Internet, find new websites that may be of interest to you,
      receive recommendations of websites from OpenLikes, and join a community of individuals with
      similar tastes and interests (collectively, the <strong>“Services”</strong>).
    </p>
    <p>
      <strong>At OpenLikes, our proprietary and constantly-evolving database helps you to connect with others who share your interests.</strong>
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
